module.exports = __webpack_public_path__ + "9788f41e/img/share-action-icon.9c12578c.svg";